module.exports = __webpack_public_path__ + "static/media/sky-back.d3efe10c.jpg";